module.exports = __webpack_public_path__ + "static/media/NTGS_landing.c748421d.png";